import {Agent, IAgentDTO} from "@/models/Agent";
import {ISegmentationSlimDTO, SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";
import {User} from "@/models/User";

export class AgentTree extends Agent {
    segmentation: SegmentationTarget | null;
    children: AgentTree[] | null;

    constructor(dto?: IAgentTreeDTO)
    constructor(
        id?: string,
        name?: string,
        parentId?: string,
        user?: User,
        children?: AgentTree[] | null,
        segmentation?: SegmentationTarget,
    )
    constructor(
        idOrDto: string | IAgentTreeDTO = "",
        name = "",
        parentId = "",
        user = new User(),
        children: AgentTree[] | null = null,
        segmentation: SegmentationTarget = new SegmentationTarget(),
    ) {
        if (typeof idOrDto !== "string") {
            super(idOrDto)
            this.children = idOrDto.isHasChildren ? [] : null;
            this.segmentation = idOrDto.segmentation ? new SegmentationTarget(idOrDto.segmentation) : null;
        } else {
            super(idOrDto, name, parentId, user)
            this.children = children;
            this.segmentation = segmentation;
        }
    }

    get treeChildren(): AgentTree[] | undefined {
        return this.children ?? undefined;
    }

    static sortChildren(items: AgentTree[]): void {
        items.sort((a, b) => {
            const nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();

            if (nameA < nameB) //sort string ascending
                return -1;
            if (nameA > nameB)
                return 1;

            return 0; //default return value (no sorting)
        });
    }
}

export type IAgentTreeDTO = IAgentDTO & Readonly<{
    isHasChildren: boolean;
    segmentation: ISegmentationSlimDTO | null;
}>
